/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-21 16:41:20
 */
import React from "react";
import {LayoutIndex} from "@/routers/constant";
import {RouteObject} from "@/routers/interface";
import AdAccount from "@/pages/AdAccount/index";
import MenuIcon from "@/routers/menu_icon";
import icon from "@/assets/icons/menu/账户.png";
import ADList from "@/pages/Admenergement"

// dashboard 模块
const dashboardRouter: Array<RouteObject> = [
	{
		element: <LayoutIndex/>,
		path: "/ad",
		meta: {
			title: "Account",
		},
		icon: <MenuIcon src={icon}/>,
		children: [
			{
				path: "/ad/adlist",
				// element: lazyLoad(React.lazy(() => import("@/pages/AdAccount/index"))),
				element: <ADList/>,
				meta: {
					requiresAuth: true,
					title: "Ad List",
					key: "account"
				}
				// icon: "CopyOutlined"
			}
		]
	}
];

export default dashboardRouter;
